// extracted by mini-css-extract-plugin
module.exports = {"tag":"repayment_tag__4RFcX"};